
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskInstanceDocumentDialog extends SiteEntityDialog<TaskInstanceDocumentRow, any> {
        protected getFormKey() { return TaskInstanceDocumentForm.formKey; }
        protected getIdProperty() { return TaskInstanceDocumentRow.idProperty; }
        protected getLocalTextPrefix() { return TaskInstanceDocumentRow.localTextPrefix; }
        protected getNameProperty() { return TaskInstanceDocumentRow.nameProperty; }
        protected getService() { return TaskInstanceDocumentService.baseUrl; }

        protected form = new TaskInstanceDocumentForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            if (this.isEditMode() && (this.entity.DocumentGroup || "").toLowerCase() != "upload") {
                this.toolbar.findButton('edit-button').hide();
            }

            this.cloneButton.hide();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            WorkflowInstanceDocumentDialog.fixDocumentStoreThumb(this.form.DocumentId,
                this.entity.DocumentId, this.entity.DocumentName, this.entity.DocumentVersion);
        }
    }
}